module.exports = __webpack_public_path__ + "static/media/service_private-room-back.d6b801f3.jpg";